/**
 * IAM routes on the user-management gateway (`/user-management/api/...`).
 * See {@link iamBackendUrl} in `src/config/backend.ts`.
 */
import { iamBackendUrl } from './backend';
/** Build IAM URL (`/user-management/api/...` relative or absolute against {@link BACKEND_URL}). */
export function userIamUrl(pathFromUserSlash) {
    const rel = pathFromUserSlash.startsWith('/') ? pathFromUserSlash : `/${pathFromUserSlash}`;
    return iamBackendUrl(rel);
}
